import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getReferralCode() {
    const { apiGetReferralCode } = apiConfig.getStaticUrls();

    return getFetch(apiGetReferralCode);
}
